/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadAccessGrantRpc
 */
import * as References from './ThreadAccessGrantRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.ThreadAccessGrantRpc#grantThreadAccess
 */
export const GRANT_THREAD_ACCESS_MUTATION_FIELD_NAME = 'com_hubspot_support_portal_rpc_ThreadAccessGrantRpc_grantThreadAccess';
export const GRANT_THREAD_ACCESS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GRANT_THREAD_ACCESS_MUTATION_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.grantThreadAccessRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});